import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup, Checkbox } from 'react-bootstrap';

const ExpiredQuotation = (props) => {
  return (
    <FormGroup controlId="expiredQuotation">
      <Col sm={1}>
        <Checkbox
          inline
          onClick={props.handleChangeExpiredQuotation}
          checked={props.expiredQuotation}
          name="expiredQuotation" />
      </Col>
      <Col componentClass={ControlLabel} sm={11}>
        Retrieve Expired Quotation
      </Col>
    </FormGroup>
  )
}

ExpiredQuotation.propTypes = {
  expiredQuotation: PropTypes.bool,
  handleChangeExpiredQuotation: PropTypes.func
};

export default ExpiredQuotation;



// WEBPACK FOOTER //
// ./src/app/components/retrieveQuotationComponent/expiredQuotation/ExpiredQuotation.js